import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SignupStepTwoComponent } from './signup-step-two.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { ClickOutsideDirective } from 'src/app/directives/click-outside.directive';


@NgModule({
  declarations: [
    SignupStepTwoComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ClickOutsideDirective,
    ComponentsModule
  ]
})
export class SignupStepTwoModule { }